import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Loading from '@/components/widgets/Loading.vue'
import Paginate from "@/components/widgets/pagination.vue";
import UploadSlip from "@/pages/admin/receivable/deposit/widget-upload-slip";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})
export default {
  components: {
    DatePicker,
    Loading,
    Paginate,
    UploadSlip
  },
  data: function() {
    return {
      role: "",
      branch: "",
      loading: false, 
      busy: false,
      apiStatus: 'ไม่พบข้อมูล',
      totalItem: 0,
      keyword_status: null,
      keyword_payment: null,
      keyword: '',
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      slipOpened: false,
      selectedUuid: null,
      fields: [
        {
          key: 'document_no',
          label: 'เลขที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'paid_at', 
          label: 'วันที่จ่าย',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true 
        },
        // { 
        //   key: 'quotation.quotation_no', 
        //   label: 'เลขที่ใบเสนอราคา',
        //   thClass: 'font-weight-bold text-xs-1/2',
        //   tdClass: 'td-top text-xs-1/2',
        //   sortable: true 
        // },
        { 
          key: 'customer.name', 
          label: 'ลูกค้า',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true, 
        },
        {
          key: 'tax_type',
          label: 'VAT ของบิลที่นำไปใช้',
          thClass: 'font-weight-bold text-xs-1/2 text-center',
          tdClass: 'td-top text-xs-1/2 text-center',
          sortable: true
        },
        {
          key: 'amount',
          label: 'มูลค่ามัดจำ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true,
          class: 'text-right'
        },
        { 
          key: 'creator_detail.name', 
          label: 'ผู้จัดทำ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true, 
          class: 'text-left' 
        },
        { 
          key: 'status', 
          label: 'สถานะ', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'action', 
          label: '#', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          class: 'text-right' 
        }
      ],
      items: []
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    async getRole(){
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id
    },
    ondeleted(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการจะยกเลิกใบมัดจำนี้หรือไม่?</span>'+
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว ข้อมูลจะไม่สามารถกู้คืนกลับมาได้?</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          this.loading = true
          this.onConfirmDelete(id)
        }
      })
    },
    async onConfirmDelete(id) {
      try {
        const param = {
          id: id
        }
        const result = await this.$store.dispatch('Deposit/delete', param, { root: true })
        setTimeout(() => {
          this.loading = false  
          if (result.status === 204) {            
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
                '<div class="d-flex flex-column">'+
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
                '<span class="text-base text-left text-gray-500">ยกเลิกใบมัดจำเรียบร้อยแล้ว</span>'+
                '</div>'+
              '</div>',
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  popup: 'swal2-custom-rounded',
                  closeButton: 'text-3xl swal2-custom-close',
                  actions: 'justify-content-end',
                  contant: 'd-flex flex-row justify-content-around px-2',
                  title: 'd-none',
                  confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                  cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
                },
                cancelButtonColor: '#dc4a38',
                cancelButtonText: 'ยกเลิก',
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                showCloseButton: true,
            }).then(async confirm => {
              if(confirm.value){
                this.onInitData(this.currentPage)
              }
            })          
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onedit(uuid) {
      this.$router.push("/deposit/added/" + uuid)
    },
    oninfo(uuid) {
      this.$router.push("/deposit/info/" + uuid)
    },
    oncreate() {
      this.$router.push("/deposit/added")
    },
    // เปิด drawer แนบสลิปของใบมัดจำใบที่เลือก
    onUploadSlip(uuid) {
      this.selectedUuid = uuid
      this.slipOpened = true
    },
    // ปิด drawer แล้วรีเฟรชรายการ (เพื่อให้สถานะ is_waiting_for_pay อัพเดต)
    onCloseSlip() {
      this.slipOpened = false
      this.selectedUuid = null
      this.onInitData(this.currentPage)
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage
      try {
        // this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const page = currentPage ? currentPage : 1
        const query = new URLSearchParams({
          page: String(page),
          perPage: "8",
          keyword: this.keyword != null ? String(this.keyword) : "",
          keyword_status: this.keyword_status != null ? String(this.keyword_status) : "",
          keyword_payment: this.keyword_payment != null ? String(this.keyword_payment) : "",
        })
        const url = `${Vue.prototype.$host}/api/v1/deposits?${query.toString()}`
        const param = {
          keyword: this.keyword,
          keyword_status: this.keyword_status,
          url: url
        }
        const result = await this.$store.dispatch('Deposit/getAll', param, { root: true })
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        
        if (result) {
          this.currentData = result.data;
          this.items = result.data.data
          this.totalItem = result.data.total
        } else {
          this.items = []
          this.totalItem = 0
        }
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    }
  },
  mounted() {
    this.onInitData(1)
    this.getRole()
  }
}
